import { Injectable, OnInit } from "@angular/core";
import { DefaultEventsMap } from "@socket.io/component-emitter";
import { io, Socket } from "socket.io-client";
import { Action, Store } from "@ngrx/store";
import {User} from "../auth/primitives/user";
import {WebsocketService} from "./websocket.service";
import {selectCameraTarget} from "../state/camera/camera.selector";
import * as AuthSelectors from '../state/auth/auth.selector';
import {entityActions} from "../state/entities/entity.actions";
import {IHasSocket} from "./i-has-socket";
import {selectNetworkReady} from "../state/network/network.selector";
import {FriendReaction} from "../state/reactions/reactions.model";
import {generateUUID} from "three/src/math/MathUtils.js";
import {ReactionsActions} from "../state/reactions/reactionsActions";
import {selectWorldReady} from "../state/world/world.selector";
import * as networkSelectors from "../state/network/network.selector";
import {DoWhenReadyService, Readyables} from "./do-when-ready.service";

@Injectable({
  providedIn: "root",
})
export class ReactionsService implements IHasSocket {
    namespace = "reactions"
  public socket: Socket<DefaultEventsMap, DefaultEventsMap>;

  user: User = null

  constructor(
      private store: Store,
      private websocketService: WebsocketService,
      private doWhenReady: DoWhenReadyService,
  ) {
      this.websocketService.reactionsSocket.subscribe(async (socket) => {
          if (!socket) return
          this.socket = socket
          this.socket.connect()
          this.setupEventHandlers()
          await this.seedCoordReactions()
      })
      this.store.select(AuthSelectors.selectAuthIsReady).subscribe(async ({authReady, user, isGuest}) => {
          if (!user) return
          this.user = user
      })
  }

  setupEventHandlers() {
      this.socket.on("UpdateReactions", async (data) => {
          await this.processReactions(data)
      });
  }

  async seedCoordReactions() {
      const data = {
      }
      try {
          const response:any = await this.socket.emitWithAck(
              'get_friends_reactions_in_coord', {
                  "coord": "coord_0-0-0",
              }
          );
          console.log("Got friends reactions: " )
          await this.processSeededReactions(response)
      } catch (err) {
          console.error(err)
          throw(err)
      }
  }

  async processSeededReactions(reactions: {[entityId: string]: {reactions: {[friendId: string]: string}}}) {
      let result = []
      for (let entityId of Object.keys(reactions)) {
          const friendReactionOnEntity = reactions[entityId].reactions
          for (let friendId of Object.keys(friendReactionOnEntity)) {
              const reactionString = friendReactionOnEntity[friendId]
              const friendReaction: FriendReaction = {
                  id: generateUUID(),
                  entityId,
                  friendId,
                  reactionString
              }
              result.push(friendReaction)
          }
      }
      this.store.dispatch(ReactionsActions.foundFriendReactions({
          friendReactions: result
      }))
  }



  async react(
      {reactionString, referenceId, referenceType, remove = false}: {
        reactionString: string,
        referenceId: string,
        referenceType: string,
        remove?: boolean
      }
  ) {
    const data = {
        reactorId: this.user?.id,
        reactorType: "user",
        action: remove ? "remove" : "add",
        reactionString,
        referenceId,
        referenceType
    }
    try {
      const response = await this.socket.emitWithAck('react', data);
        debugger;
    } catch (err) {
      throw(err)
    }
  }

  async processReactions(data ) {
    const referenceId = data["referenceId"]
    const referenceType = data["referenceType"]
    const reactions = data["reactions"]
    if (referenceType === "entity") {
      this.store.dispatch(entityActions.updatedReactions({
        entityId: referenceId,
        newReactionProperties: {
          commonReactionsCounters: reactions,
          smallScaleReactions: []
        }
      }))
    }
  }
}
